import { ColorsIcon, FilterOdometerIcon } from '../../assets';
import { Tag } from '../../models/Listing';
import type { Vehicle } from '../../types/api.graphql';
import { capitalizeFirstLetter } from '../../utils/string';
import { PillProps } from '../Pill/Pill';
import { DateBox } from './VehicleDateBox';
import { MoneyBox } from './VehicleMoneyBox';
import { PillBox } from './VehiclePillBox';
import { ShimmerBox } from './VehicleShimmerCard';
import { TagsBox } from './VehicleTagsBox/VehicleTagsBox';
import { TextBox } from './VehicleTextBox';
import { TextWithActionsBox } from './VehicleTextWithActionBox';

export const createTextBox = (
  title: string,
  value1: string,
  icon1?: JSX.Element,
  value2?: string,
  icon2?: JSX.Element,
  value3?: string,
  icon3?: JSX.Element,
  minWidth?: number,
  maxWidth?: number,
  style?: React.CSSProperties,
): TextBox => {
  return {
    title,
    value1,
    icon1,
    value2,
    icon2,
    value3,
    icon3,
    type: 'TextBox',
    minWidth,
    maxWidth,
    style,
  };
};

export const createTextWithActionBox = (
  title: string,
  value1: string,
  icon1?: JSX.Element,
  action1?: any,
  value2?: string,
  icon2?: JSX.Element,
  action2?: any,
  iconSize?: string,
): TextWithActionsBox => {
  return {
    title,
    value1,
    icon1,
    action1,
    value2,
    icon2,
    action2,
    iconSize,
    type: 'TextWithActionsBox',
  };
};

export const createMoneyBox = (
  title: string,
  currency: 'USD' | 'CAD',
  amount: number,
  value1?: string,
  icon1?: JSX.Element,
): MoneyBox => {
  return {
    title,
    currency,
    amount,
    value1,
    icon1,
    type: 'MoneyBox',
  };
};

export const createDateBox = (title: string, date: Date, minWidth?: number): DateBox => {
  return {
    date,
    title,
    type: 'DateBox',
    minWidth,
  };
};

export const createTagsBox = (title: string, tags: Tag[], minWidth?: number): TagsBox => {
  return {
    title,
    type: 'TagsBox',
    tags,
    minWidth,
  };
};

export const createPillBox = (title: string, pill: PillProps, minWidth?: number, maxWidth?: number): PillBox => {
  return {
    pill,
    title,
    type: 'PillBox',
    minWidth,
    maxWidth,
  };
};

export const createShimmerBox = (
  title: string,
  shimmerValue: JSX.Element,
  minWidth?: number,
  maxWidth?: number,
): ShimmerBox => {
  return {
    title,
    shimmerValue,
    type: 'ShimmerBox',
    minWidth,
    maxWidth,
  };
};

/**
 * @param vehicle
 * @param t
 * @returns text box with vehicle's mileage and colors.
 */
export const vehicleInformationBox = (vehicle: Vehicle, t: (...args: any) => string) => {
  return createTextBox(
    'Vehicle information',
    `${Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(vehicle?.odometer)} ${
      vehicle?.odometerUnit === 'mi' ? 'miles' : vehicle?.odometerUnit ?? 'miles'
    }`,
    <FilterOdometerIcon />,
    `${capitalizeFirstLetter(vehicle?.exteriorColor || t('common.noInformation'))}${
      vehicle?.interiorColor ? '/' + capitalizeFirstLetter(vehicle?.interiorColor) : ''
    }`,
    <ColorsIcon />,
  );
};
